/**
 * Tab Component
 *
 * @file tooltip.js
 */

const tooltip = (() => {
  /**
   * Default Tab
   * Project default tab style
   */
  const asistanTooltip = () => {
    document.addEventListener("DOMContentLoaded", function() {
      const tooltips = document.querySelectorAll('.data-sp-tooltip');
  
      tooltips.forEach(tooltip => {
          const tooltipText = tooltip.getAttribute('data-title');
  
          if (tooltipText) { // data-title mevcutsa
              tooltip.insertAdjacentHTML('beforeend', `<span class="data-asistan-tooltip">${tooltipText}</span>`);
          }
      });
  });
  };

  const init = () => {
    asistanTooltip();
  };

  return {
    init,
  };
})();

export default tooltip;
